import { CloseOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import { Input } from '@mm/components';
import styles from './EditWebsiteURL.module.css';
import { URL_REGEX } from '../../../../common/constants/validations';
import validator from 'validator';
import { Routes } from '../../../../routes/top-level-routes';
import { extractDomainName } from '../WebsiteReportSummary/constants';

export const EditWebsiteURL = ({
  onClose,
  hideClose,
}: {
  onClose: () => void;
  hideClose?: boolean;
}) => {
  const [urlError, setUrlError] = useState(false);
  const [websiteURL, setWebsiteURL] = useState('');

  const onSubmit = async () => {
    const isValidURL = validator.isURL(websiteURL);
    if (isValidURL && websiteURL) {
      const domainName = extractDomainName(websiteURL);

      if (domainName) {
        window.location.replace(Routes.report.getLink(domainName));
      }
    } else {
      setUrlError(true);
    }
  };

  return (
    <div className={styles.container}>
      {!hideClose && (
        <CloseOutlined className={styles.closeIcon} onClick={onClose} />
      )}

      <div className={styles.title}>
        <div className={styles.heading}>Enter your website URL </div>
        <div className={styles.subHeading}>
          {' '}
          to get 50 FREE contacts from your existing traffic
        </div>
      </div>

      <div className={styles.form}>
        <Input
          type="text"
          css={{ container: styles.input }}
          placeholder="yourdomain.com"
          value={websiteURL}
          onChange={e => setWebsiteURL(e.target.value)}
        />
        {urlError && (
          <div>Please, enter only website domain name e.g. example.com</div>
        )}
        <PrimaryButton
          className={styles.button}
          onClick={onSubmit}
          disabled={!websiteURL || !URL_REGEX.test(websiteURL)}
        >
          Claim my website visitor list now
        </PrimaryButton>
      </div>
    </div>
  );
};
